module.exports = __webpack_public_path__ + "img/0.a3196716.png";